import { useBookingsContext } from "../hooks/useBookingsContext"
import { useAuthContext } from "../hooks/useAuthContext"
import { useState } from "react"
import { strings } from "../strings"
import '../styling/bookingDetails.css'
import DeleteEventDialog from "./dialogs/DeleteEventDialog"
import LimitDialog from "./dialogs/LimitDialog"

const BookingDetails = ({ booking }) => {

    const { dispatch } = useBookingsContext()
    const { user } = useAuthContext()

    const [error, setError] = useState(null)
    const [open, setOpen] = useState(false)
    const [limitOpen, setLimitOpen] = useState(false)

    const startDate = new Date(booking.start)
    const month = startDate.getMonth() + 1
    const end = new Date(startDate.getTime() + 90*60000);
    const startMinutes = ('0'+ startDate.getMinutes()).slice(-2)
    const endMinutes = ('0'+ end.getMinutes()).slice(-2)
    const formattedTimeString = startDate.getDate() + "/" + month + " " + startDate.getHours() + ":" + startMinutes + " - " + end.getHours() + ":" + endMinutes
    const machines = booking.machineID === 1 ? strings.laundry.machine1 : booking.machineID === 2 ? strings.laundry.machine2 : strings.laundry.bothMachines

    const openConfirmationDialog = () => {
        setOpen(true)
    }

    const confirmDelete = async () => {
        if (!user) {
            return
        }

        setError(null)
        setOpen(false)

        const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/bookings/' + booking._id, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${user.token}`
            }
        })

        const json = await response.json()

        if (!response.ok) {
            setError(json.msg)
        }

        if (response.ok) {
            setError(null)
            dispatch({ type: 'DELETE_BOOKING', payload: json })
        }
    }

    const cancelDelete = () => {
        setOpen(false)
    }

    const openTooLateDialog = () => {
        setLimitOpen(true)
    }

    const closeTooLateDialog = () => {
        setLimitOpen(false)
    }

    const handleDelete = () => {

        let hours = Math.abs(startDate - new Date()) / 36e5

        if (hours <= 1) {
            openTooLateDialog()
        } else {
            openConfirmationDialog()
        }
    }

    return (
        <div className="booking-details">
            <DeleteEventDialog open={open} closeConfirm={confirmDelete} closeCancel={cancelDelete} />
            <LimitDialog open={limitOpen} closeDialog={closeTooLateDialog} limit={strings.dialogs.tooLate} title={strings.dialogs.tooLateTitle} />

            <h4>{booking.facility}</h4>
            {booking.facility !== strings.balcony.balcony && <p>{machines}</p>}
            <p>{formattedTimeString}</p>
            <span onClick={handleDelete}>{strings.myBookings.cancel}</span>
            {error && <div className="error">{error}</div>}
        </div>
    )
}

export default BookingDetails
